import React, { Component } from 'react'
import IrregularInteraction from '../../IrregularInteraction'
import ItemImage from '../../ItemImage'
import Frame1Image from '../../../assets/images/bedroom/item--speakers--f1@3x.png'
import Frame2Image from '../../../assets/images/bedroom/item--speakers--f2@3x.png'

const pointsLeft =
  '0 38.85 0 57.35 10.9 63.65 21.81 57.35 21.81 38.85 10.9 32.55 0 38.85'

const pointsRight =
  '78.08 6.3 67.18 0 56.28 6.3 61.71 9.45 56.28 6.31 56.28 24.81 67.18 31.1 78.08 24.81 78.08 6.31 72.65 9.45 78.08 6.3'

export default class Speakers extends Component {
  static propTypes = IrregularInteraction.propTypes

  constructor(props) {
    super(props)

    this.state = {
      animate: props.animate,
    }
  }

  handleClick() {
    if (this.state.animate) this.setState({ animate: false })
  }

  render() {
    const { animate } = this.state

    return (
      <IrregularInteraction
        points={pointsLeft}
        preserveAspectRatio="xMidYMin meet"
        viewBox="0 0 78.08 63.65"
        {...this.props}
        onClick={() => {
          this.props.onClick && this.props.onClick()
          this.handleClick()
        }}
        showSparks={false}
      >
        <IrregularInteraction
          points={pointsRight}
          preserveAspectRatio="xMidYMin meet"
          viewBox="0 0 78.08 63.65"
          {...this.props}
          onClick={() => {
            this.props.onClick && this.props.onClick()
            this.handleClick()
          }}
          sparksTop={-47}
          sparksLeft={117}
          sparksRotation={-85}
        >
          <ItemImage src={animate ? Frame2Image : Frame1Image} />
        </IrregularInteraction>
      </IrregularInteraction>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/items/bedroom/Speakers.js